import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Category } from '../interfaces/category.interface';

const apiUrl = environment.apiUrl + 'guest/';

@Injectable({
  providedIn: 'root',
})
export class CategoryService {
  categoryObservable: Observable<any> | undefined;
  pulledOutCategories: Category[] = [];
  categorySlugs: any = [];

  constructor(private http: HttpClient) {}

  getCategories() {
    if (!this.categoryObservable) {
      this.categoryObservable = this.http.get(apiUrl + 'categories').pipe(
        map((res: any) => {
          const categories: Category[] = res.data;
          return {
            categories: categories,
            treeCategories: this.getTreeCategories(categories),
          };
        }),
        shareReplay(1)
      );
    }
    return this.categoryObservable;
  }

  getShopCategories(slug: string) {
    return this.http.get(apiUrl + `shop/${slug}/categories`).pipe(
      map((res: any) => {
        const categories: Category[] = res.data;
        return {
          categories: categories,
          treeCategories: this.getTreeCategories(categories),
        };
      }),
      shareReplay(1)
    );
  }

  findCategoryBySlug(slug: string, categories: Category[]) {
    return categories.filter((category) => {});
  }

  private getTreeCategories(categories: Category[]) {}

  private checkTreeCategoriesChildren(pChildren: Category[]) {}

  filterCategorySlugWithParent(pCategories: Category[], slug: string) {
    const categories: Category[] = this.pullOutCategories(pCategories);
    this.categorySlugs = [];
    let foundCategory = categories.find(
      (category: Category) => category.slug === slug
    );
    this.categorySlugs.push(foundCategory?.slug);
    if (foundCategory?.parent_id != null) {
      this.findCategorySlugParent(categories, foundCategory.parent_id);
    }
    return this.categorySlugs.reverse();
  }

  private findCategorySlugParent(categories: Category[], parentId: number) {
    let foundCategory = categories.find((cat: Category) => cat.id === parentId);
    this.categorySlugs.push(foundCategory?.slug);
    if (foundCategory?.parent_id != null) {
      this.findCategorySlugParent(categories, foundCategory.parent_id);
    }
  }

  getCategoryParent(pCategories: Category[], parentId: string) {}

  private pullOutCategories(categories: Category[]) {
    this.pulledOutCategories = [];
    categories.forEach((cat) => {
      this.pulledOutCategories.push(cat);
      if (cat.children.length > 0) {
        cat.children.forEach((child) =>
          this.checkPullOutCategoryChildren(child)
        );
      }
    });
    return this.pulledOutCategories;
  }

  private checkPullOutCategoryChildren(children: Category) {
    if (children) {
      this.pulledOutCategories.push(children);
      if (children.children.length > 0) {
        children.children.forEach((child) =>
          this.checkPullOutCategoryChildren(child)
        );
      }
    }
  }
}
